import EventSearch from "@grindex-client/components/Search/Pages/event-search.class";

function init($views: HTMLElement[]) {
	const $module = $views[0];
	const search = new EventSearch($module);

	search.search();
}

export default {
	view: "event-searchPage",
	init,
};
